import Home from '../pages/Home';
import Services from '../pages/Services';
import Contact from '../pages/Contact';
import Cars from '../pages/CarsPage';
import CarDetail from '../components/CarDetail';

const Routes = [
  { url: '/', exact: true, comp: Home },
  { url: '/chauffeur-prive', exact: false, comp: Services },
  { url: '/contact', exact: false, comp: Contact },
  { url: '/cars/:id', exact: true, comp: CarDetail },
  { url: '/cars', exact: true, comp: Cars } ,
];

export default Routes;
